export enum SciTheme {
  SCI = 'sci',
  PayForU = 'payforu',
  Light = 'light',
  SQ = 'sq',
}

export const SciThemeToUppyDialogMap: Record<
  SciTheme,
  'light' | 'dark' | 'auto'
> = {
  [SciTheme.SCI]: 'dark',
  [SciTheme.PayForU]: 'dark',
  [SciTheme.Light]: 'light',
  [SciTheme.SQ]: 'light',
};
